import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { serverUrl } from '../../../Constant/Static/config';
import Loader from '../../../Constant/Custom/Loader';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function Religion() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [csrfToken, setCsrfToken] = useState('');

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (csrfToken) {
                try {
                    const response = await axios.post(
                        `${serverUrl}/api/admin/stats/religion`,
                        {},
                        {
                            headers: {
                                'CSRF-Token': csrfToken
                            },
                            withCredentials: true
                        }
                    );
                    const counts = response.data;

                    const labels = [...new Set(counts.map(item => item.religion))];
                    const genders = [...new Set(counts.map(item => item.gender))];

                    const datasets = genders.map(gender => ({
                        label: gender,
                        data: labels.map(religion => {
                            const item = counts.find(c => c.religion === religion && c.gender === gender);
                            return item ? item.count : 0;
                        }),
                        backgroundColor: gender === 'Male' ? '#36A2EB' : '#FF6384',
                    }));

                    setData({
                        labels,
                        datasets,
                    });
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchData();
    }, [csrfToken]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Religion',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Count',
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <div>
            <h4>Applicant Counts by Religion and Gender</h4>
            {loading ? <Loader /> : <Bar data={data} options={options} />}
        </div>
    );
}

export default Religion;
